"use client";

import { PillButton } from "@/components/site/PillButton";
import { SideTickList } from "@/components/site/SideTickList";
import { SplitTarget } from "@/components/site/SplitTarget";
import { useContent } from "@/components/site/ContentProvider";

function MagnetCta({ label }: { label: string }) {
  return (
    /* No `_ele` — swapSide must not re-stagger the CTA on service hover. */
    <div className="side_btm">
      <PillButton
        label={label}
        className="jump_link"
        data-section="contact"
      />
    </div>
  );
}

export function SideLeft() {
  const site = useContent();
  return (
    <div className="side_wrap side_left desktop">
      <div className="side_container f a-c j-e side-work">
        {/* Lead copy removed — Our Work speaks through the grid + cases. */}
        <MagnetCta label={site.labels.contactUs} />
      </div>
      {site.projects.map((project) => (
        <div
          className={`side_container f a-c j-e side-${project.id}`}
          key={project.id}
        >
          <div className="side_mdl f f-c a-e">
            {/* Title lives centered in `#projects`; sidebar keeps description only. */}
            <SplitTarget
              className="side_case_body uppercase _split"
              text={project.description}
            />
          </div>
          <MagnetCta label={site.labels.contactUs} />
        </div>
      ))}
      {site.services.map((service, i) => (
        <div
          className={`side_container f a-c j-e side-service-${i + 1}`}
          key={service.name}
        >
          <div className="side_mdl">
            <SplitTarget text={service.description} />
          </div>
          <MagnetCta label={site.labels.contactUs} />
        </div>
      ))}
      {site.products.map((product, i) => (
        <div
          className={`side_container f a-c j-e side-product-${i + 1}`}
          key={product.id}
        >
          <div className="side_mdl">
            <div className="product_info f f-c">
              <span className="uppercase _ele product_side_title">
                {product.name}
              </span>
              {/* Plain `_ele` (not SplitTarget) so swapSide/snapSide always reveal it. */}
              <span className="uppercase _ele">{product.sideDescription}</span>
              <SideTickList title={product.modulesLabel} items={product.modules} />
              <SideTickList
                title={product.integrationsLabel}
                items={product.integrations}
              />
            </div>
          </div>
          <MagnetCta label={site.labels.bookDemo} />
        </div>
      ))}
      <div className="side_container f a-c j-e side-story">
        <div className="side_mdl">
          <SplitTarget text={site.about.body} />
        </div>
        <MagnetCta label={site.labels.contactUs} />
      </div>
      <div className="side_container f a-c j-e side-contact">
        <div className="side_mdl">
          <SideTickList title={site.labels.focus} items={site.sideContactFocus} />
        </div>
        <div className="side_btm">
          <SplitTarget text={site.sideContact} />
        </div>
      </div>
    </div>
  );
}
